import React, { Component } from 'react';
import { Card, CardText } from 'material-ui/Card';
import Form from '../Common/Form.react';
import TextField from '../Common/TextField';
import LabelActions from '../../actions/LabelActionCreator';

class LabelForm extends Component {

    constructor (props) {
        super(props);
        this.state = {
            name: '',
            description: '',
        };
    }

    render() {

      const url = '/dashboard/labels';

      return(
            <Form
                title="New label"
                onSave={this.submitForm}
                onCancel={this.onCancel}
                redirectTo={url}
            >
                <Card className="cent-card">
                    <CardText>
                        <TextField
                            name="name"
                            value={this.state.name}
                            validations="minLength:2,maxLength:255"
                            validationError="Please use only letters, at least 2"
                            hintText="Name"
                            floatingLabelText="Name"
                            required
                        />
                    </CardText>
                </Card>
            </Form>
      );
    }

    submitForm(model) {
        return LabelActions.save(model);
    }

    onCancel() {
        window.location.href = '/dashboard/labels'
    }

    onChange() {
    }
}

export default LabelForm;
